/** View-Modell + Status eines Felds im Optimierungen-Drawer. */
import type { ContentFieldSuggestion } from '@/lib/api/channel-content'

import type { OptimierungErrorKind } from './OptimierungErrorCard'
import type { FieldKind } from './tokens'

export type FieldStatus = 'rest' | 'busy' | 'suggestion' | 'applied' | 'error'

export type AttributeCode = 'title' | 'description' | 'short_description' | 'bullets'

export interface OptimierungField {
  attributeCode: AttributeCode
  kind: FieldKind // err | warn | new(proaktiv) | done — Steuerung der Row-Optik
  status: FieldStatus
  statusLabel: string // "Regel verletzt" | "Fehlt" | "Proaktiv"
  reason: string
  cost: number
  proactive: boolean // true = kein Verstoß → nicht im Sammel-Lauf
  suggestion?: ContentFieldSuggestion
  errorKind?: OptimierungErrorKind
  errorDetail?: string
  appliedSnippet?: string
}

/** Unveränderlich ein Feld patchen. */
export function patchField(
  fields: OptimierungField[],
  code: string,
  patch: Partial<OptimierungField>,
): OptimierungField[] {
  return fields.map((f) => (f.attributeCode === code ? { ...f, ...patch } : f))
}

/** Kurzes Snippet eines (übernommenen) Werts für die Done-Row. */
export function snippetOf(value: string | string[]): string {
  if (Array.isArray(value)) {
    return value.length ? `${value[0]}${value.length > 1 ? ` … +${value.length - 1} weitere` : ''}` : ''
  }
  return value
}
